module.exports = __webpack_public_path__ + "img/instance2.78d7424d.png";